export default __webpack_public_path__ + "media/images/news-01-370x270-2f90c49efde42ea693134018d7ebe37b.jpg";